
import axios from 'axios'
import { Toast } from 'we-vue'
import { getOpenid } from '@/utils/auth'
// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 15000 // 请求超时时间
})

// request拦截器
export function bindOpenIdToRequest(){
  service.interceptors.request.use(config => {
    let openid = getOpenid();
    if(openid) {
      config.headers.WechatOpenid = getOpenid()
    }
    return config
  }, error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error)
  })
}
service.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    const res = error.response.data;
    if (error.response) {
      switch (error.response.status) {
        case 400:
        {
          console.log(res);
          Toast({
            duration: 3000,
            message: res.message,
            type: 'text'
          });
          break;
        }

        case 401:
        {
          document.location.href = res.redirect_url;
          break
        }
        case 402:
        {
          document.location.href = res.redirect_url;
          break;
        }
      }
    }
    return Promise.reject(error)
  },
  result => {
    //
  }
);

export default service




// WEBPACK FOOTER //
// ./src/utils/request.js